module.exports = __webpack_public_path__ + "static/media/19.34798712.wav";